import React from 'react'
import gql from 'graphql-tag'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {fromGlobalId} from 'lib/util'
import Layout from 'components/shared/Layout'
import Heading from 'components/shared/Heading'
import Query from 'components/shared/Query'
import Button from 'components/shared/Button'
import './index.scss'

const orderRecipientQuery = gql`
  query OrderRecipientQuery($id: ID!) {
    order(id: $id) {
      id
      invisoRef
      estateContactEmail
      estateCustomerName
      broker {
        id
        email
      }
      estate {
        id
        tasks {
          id
          title
        }
      }
      attendances(state: booked) {
        id
        resourceName
        startsAt
      }
    }
  }
`

const Recipient = (props) => {
  const readableOrderNumber = (id) => fromGlobalId(id).id

  return (
    <Layout documentTitle="Ordrebekreftelse">
      <div className="new-order recipient">
        <Heading level={2}>Bestillingen din er bekreftet!</Heading>

        <Query
          inlineLoading
          inlineError
          query={orderRecipientQuery}
          variables={{id: props.match.params.orderId}}
        >
          {({getData}) => {
            const order = getData('order')
            let attendance = null
            if (order.attendances.length === 1) {
              attendance = order.attendances[0]
            }

            const hasTasks = !!order.estate && !!order.estate.tasks && !!order.estate.tasks.length
            const estateButtonLabel = hasTasks ? 'Fullfør bestilling' : 'Se oppdraget'

            return (
              <>
                {hasTasks && (
                  <p className="lead">Det gjenstår fremdeles oppgaver i oppdraget som må utføres for å få bestillingen <em>fullført</em>.</p>
                )}

                <div className="estate-tasks">
                  {hasTasks && (
                    <ol className="container">
                      {order.estate.tasks.map((task, i) => (
                        <li key={i}>
                          {task.title}
                        </li>
                      ))}
                    </ol>
                  )}

                  {!!order.estate && order.estate.id && (
                    <Link to={`/oppdrag/${order.estate.id}`}>
                      <Button type="action">{estateButtonLabel}</Button>
                    </Link>
                  )}

                  {(!order.estate || !order.estate.id) && !!order.broker && (
                    <p>
                      NB! Du har ikke tilgang til dette oppdraget via din epost-konto.
                      Ønsker du tilgang, ta kontakt med EFKT Kundeservice på mail; ks@efkt.com eller telefon nr 21 08 05 00.
                    </p>
                  )}
                </div>

                <div className="container confirmation">
                  <Heading level={2}>Ordrebekreftelse</Heading>

                  <p><span>Ordrenummer:</span> #{readableOrderNumber(order.id)}</p>
                  <p><span>EFKT ref:</span> #{order.invisoRef}</p>
                  <p><span>Kontaktperson på oppdraget:</span> {order.estateContactEmail}</p>
                  <p><span>Kontor:</span> {order.estateCustomerName}</p>
                  <p><span>Mailbekreftelser:</span> {order.estateContactEmail}</p>

                  {attendance && (
                    <p>{attendance.resourceName} er booket for fotografering {moment(attendance.startsAt).format('DD. MMMM YYYY, HH:mm')}.</p>
                  )}
                </div>
              </>
            )
          }}
        </Query>
      </div>
    </Layout>
  )
}

export default Recipient
